  <script>
  import LoadingIndicator from './LoadingIndicator.svelte'
  import { regSchema } from './schema';
	import { isOpen } from './stores.js';

  export let isopen;
  export let surveyid;
  export let surveyurl;

  let formVisible;
  let timeoutId;
  $: {
    if (isopen) {
      formVisible = true;
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    } else {
      timeoutId = setTimeout(() => {
        formVisible = false;
        clearTimeout(timeoutId);
        timeoutId = null; 
      }, 500);
    }
  }

  function closethis() {
    isopen = false;
    isOpen.set(false);    
  }
  
  
  // new variables 
    let id_userBrowser = navigator.appCodeName,
      id_userOS = navigator.oscpu,
      id_userPlatform = navigator.platform,
      id_userLanguage = navigator.language,
      id_userAgent = navigator.userAgent;
      
  // this is sort of lame state managment
    let waiting   = true,
        loading   = false,
        response  = false,
        success   = false,
        error     = false
   

  let values = {
    "e707a74c": "",
    "o34b5832" : "8bc152e2-ab12-4da5-b74a-d848522c3bf9"
  }
  let errors = {}
  let hide = "hide"
  const extractErrors = err => {
    return err.inner.reduce((acc, err) => {
      return { ...acc, [err.path]: err.message };
    }, {});
  };

  async function formSubmit () {
    regSchema
    .validate(values, { abortEarly: false })
    .then(() => {
      // alert(JSON.stringify(values, null, 2));
      // clear the errors
      makePost()
      errors = {};
    })
    .catch(err => (errors = extractErrors(err)));
  }

  async function makePost () {
    let id_page = "173715463",
      id_q1 = "688506995",
      choice_id = values.ctgovRadio,
      row_id = "4527714015",
      id_q2 = "688524144",
      answer_text = values.ctgovTextArea,
      id_q3 = "690010429", 
      id_survey = surveyid,
     
      surveyMonkeyRes = `{
    "pages": [
      {
          "id": "${id_page}",
          "questions": [
              {
                  "id": "${id_q1}",
                  "answers": [
                      {
                          "choice_id": "${choice_id}",
                          "row_id": "${row_id}"
                      }
                  ]
              },
              {
                  "id": "${id_q2}",
                  "answers": [
                      {
                          "text": "${answer_text}"
                      }
                  ]
              },
              {
                  "id": "${id_q3}",
                  "answers": [
                      {
                          "text": "${window.location.href}"
                      }
                  ]
              }
          ]
      }
    ],
    "custom_variables": {
      "surveyID": "${id_survey}",
      "userBrowser": "${id_userBrowser}",
      "userOS": "${id_userOS}",
      "userPlatform": "${id_userPlatform}",
      "userLanguage": "${id_userLanguage}",
      "userAgent": "${id_userAgent}"
    }
}`;
// console.log(surveyMonkeyRes)
    loading = true

    // console.log(surveyurl + ":1")
    if (!surveyurl) {
      surveyurl = "https://www.surveymonkey.com/r/GHF96NW"
    }
    // console.log(surveyurl+ ":2")

	  // const res = await fetch('https://stage-apps.ct.egov.com/sitecore-global-feedback/api/surveymonkey/collectors/408018673/responses', {
      const res = await fetch('https://egov.ct.gov/sitecore-global-feedback/api/surveymonkey/collectors/408018673/responses', {
      method: 'POST',
			body: surveyMonkeyRes,
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      }
		}).then(results => {
      // console.log(results)
      loading = false
      waiting = false
      response = true
      success = true
      error = false
    }).catch((err) => {
      // console.log("!" , err)
      loading = false
      waiting = false
      response = true
      success = false
      error = true

    });
	}

  function resetForm() {
    values.ctgovRadio = ""
    values.ctgovTextArea = ""
    waiting = true
    response = false
    success = false
  }

  function handleLabelKeyDown(event) {
    if (event.key === 'Enter' || event.key === 'Tab') {
     event.prevent_default;
    }
  }
  

  
  function handleKeyPress(event) {
    if (event.key === "Enter") {
      // Trigger the same action as the onclick event
      event.target.click;

    }
  }

</script>


<svelte:options tag="feedback-form"></svelte:options>


<div class="feedback__window {isopen ? "is-open" : ""}" role="dialog" tabindex="{isopen ? "0" : "-1"}" aria-hidden="{isopen ? "false" : "true"}">
  {#if waiting}
    <div class="feedback__main {formVisible ? "is-visible" : ""}">
      <h1>
        How was your experience today on CT.gov?
      </h1>
      <!-- FORM -->
      <!-- *** -->
      <!-- *** -->
      <!-- *** -->
      <!-- *** -->
      <!-- *** -->
      <!-- *** -->
      <!-- *** -->
      <!-- *** -->
      <form id="ctgov-global-feedback-form">

        <fieldset class="ctgov-global-feedback-fieldset rating" aria-label="Out of five stars, one being the least helpful and 5 being the most helpful, how was your experience today on CT.gov? Use the arrow keys to make your selection and press tab to continue.">
          <input id="ctgov-global-feedback-form-radio-1" type="radio" name="ctgov-global-feedback-form-radio" bind:group={values.ctgovRadio}
            value={4527714016} on:keydown={handleLabelKeyDown} >
          <label for="ctgov-global-feedback-form-radio-1">1 out of 5 star </label>
          <input id="ctgov-global-feedback-form-radio-2" type="radio" name="ctgov-global-feedback-form-radio" bind:group={values.ctgovRadio}
            value={4527714017} on:keydown={handleLabelKeyDown}>
          <label for="ctgov-global-feedback-form-radio-2">2 out of 5 stars</label>
          <input id="ctgov-global-feedback-form-radio-3" type="radio" name="ctgov-global-feedback-form-radio" bind:group={values.ctgovRadio}
            value={4527714018} on:keydown={handleLabelKeyDown}>
          <label for="ctgov-global-feedback-form-radio-3">3 out of 5 stars</label>
          <input id="ctgov-global-feedback-form-radio-4" type="radio" name="ctgov-global-feedback-form-radio" bind:group={values.ctgovRadio}
            value={4527714019} on:keydown={handleLabelKeyDown}>
          <label for="ctgov-global-feedback-form-radio-4">4 out of 5 stars</label>
          <input id="ctgov-global-feedback-form-radio-5" type="radio" name="ctgov-global-feedback-form-radio" bind:group={values.ctgovRadio}
            value={4527714020} on:keydown={handleLabelKeyDown}>
          <label for="ctgov-global-feedback-form-radio-5">5 out of 5 stars</label>
              
          <div class="stars {errors.ctgovRadio ? 'err' : ''}">
            <label class="stars__label" for="ctgov-global-feedback-form-radio-1" aria-label="1 star" title="1 star" ></label>
            <label class="stars__label" for="ctgov-global-feedback-form-radio-2" aria-label="2 stars" title="2 stars" ></label>
            <label class="stars__label" for="ctgov-global-feedback-form-radio-3" aria-label="3 stars" title="3 stars" ></label>
            <label class="stars__label" for="ctgov-global-feedback-form-radio-4" aria-label="4 stars" title="4 stars" ></label>
            <label class="stars__label" for="ctgov-global-feedback-form-radio-5" aria-label="5 stars" title="5 stars" ></label>
          
          </div>
          
          {#if errors.ctgovRadio}
            <span class="validation-error">
              {errors.ctgovRadio}
            </span>
          {/if}

        </fieldset>

        <fieldset class="ctgov-global-feedback-fieldset">
          <label class="feedback__label" for="ctgov-global-feedback-form-textarea">Any additional comments?</label>
          <textarea class="ctgov-global-feedback-form-textarea {errors.ctgovTextArea ? 'err' : ''}" id="ctgov-global-feedback-form-textarea" name="ctgov-global-feedback-form-textarea"  bind:value={values.ctgovTextArea}></textarea>
          
          {#if errors.ctgovTextArea}
            <span class="validation-error">
              {errors.ctgovTextArea}
            </span>
          {/if}
          <br>
        </fieldset>

        <div class="cthp-input-field">
          Please leave this blank
          <input type="text" name="e707a74c" bind:value={values.e707a74c} />
        </div>
        <div class="cthp-text-field {hide}">
          Please do not change this field
          <input type="text" name="o34b5832" bind:value={values.o34b5832} />
        </div>
       
        <div>
          <br>
            {#if loading} 
              <loading-indicator></loading-indicator>
            {:else}	
              <button type="button" class="btn btn-primary submit-btn ctgov-feedback-submit-button {values.ctgovTextArea &&  values.ctgovRadio ? 'valid' : 'invalid'}" id="ctgov-feedback-submit-button" toggleOpen on:click={formSubmit} on:keydown={handleKeyPress}>
                <span class="submit-text">Submit</span>
              </button>
            {/if}
                     
        </div>
      </form>

      <!-- *** -->
      <!-- *** -->
      <!-- *** -->
      <!-- *** -->
      <!-- *** -->
      <!-- *** -->
      <!-- *** -->

    </div>
  
    {/if}  
    
    {#if response}
      <div class="feedback__response">
        {#if success}

          <div class="feedback__response--success">
            <h1>Thank You</h1>
            <div class="feedback__success-circle">
              <div class="feedback__success-checkmark draw"></div>
            </div>
            
            <p>If you would like to provide more feedback please take our <a target="_blank" rel="noopener" aria-label="If you would like to provide more feedback please take our survey"
              href="{surveyurl}?Language={id_userLanguage}&SourcePage={window.location.href}&DeviceType={id_userAgent}">survey</a>.</p>
              <br><br>
              <button type="button" class="btn btn-primary reload-btn" on:click={closethis}><span class="reload">&times;</span> Close</button>
          </div>        
        {/if}
        {#if error}
          <div class="feedback__response--error">
            <div class="feedback__error-circle">
              <div class="feedback__error-point">!</div>
            </div>
            <p class="validation-error">
              There was an error trying to submit your response. Please try again later.
            </p>
            <br><br>
              <button type="button" class="btn btn-primary reload-btn-error" on:click={resetForm}><span class="reload">&#x21bb;</span> Reload</button>

          </div>
        {/if}  
      </div>
    {/if}
    </div>

<style>


  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  .feedback__window {
    display: block;
  }
  h1 {
    margin-top: 0;
    margin-bottom: 0.5rem;
  }
  p {
    margin-top: 0;
    margin-bottom: 1rem;
  }
  a {
    color: #007bff;
    text-decoration: none;
    background-color: transparent;
  }
  a:hover {
    color: #0056b3;
    text-decoration: underline;
  }
  .feedback__label {
    display: inline-block;
    margin-bottom: 0.5rem;
    font-size: 1.2rem;
    font-weight: normal;
    line-height: 1.5;
  }
  button {
    border-radius: 0;
  }
  button:focus {
    outline: 1px dotted;
    outline: 5px auto -webkit-focus-ring-color;
  }
  input,
  button,
  textarea {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
  }
  button,
  input {
    overflow: visible;
  }
  button {
    text-transform: none;
  }
  button,
  [type="button"] {
    -webkit-appearance: button;
  }
  button:not(:disabled),
  [type="button"]:not(:disabled) {
    cursor: pointer;
  }
  button::-moz-focus-inner,
  [type="button"]::-moz-focus-inner {
    padding: 0;
    border-style: none;
  }
  input[type="radio"] {
    box-sizing: border-box;
    padding: 0;
  }
  textarea {
    overflow: auto;
    resize: vertical;
  }
  fieldset {
    min-width: 0;
    padding: 0;
    margin: 0;
    border: 0;
  }
  ::-webkit-file-upload-button {
    font: inherit;
    -webkit-appearance: button;
  }
  h1 {
    margin-bottom: 0.5rem;
    font-weight: 500;
    line-height: 1.2;
  }
  h1 {
    font-size: 2.5rem;
  }
  h1 {
    color: #2d2c2c;
    font-weight: 400;
    font-family: "Lato-Bold", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    margin-bottom: 0rem;
  }
  p {
    margin-bottom: 0rem;
  }
  a {
    color: #09538b;
    text-decoration: underline;
    font-family: "Karla-Regular", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  }
  a:hover {
    color: #09538b;
  }
  .btn {
    transition: all 0.2s ease-in-out;
    border-radius: 0.25rem;
    border: none;
    position: relative;
    color: #fff;
    font-family: "Karla-Bold", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    font-size: 0.75rem;
    font-weight: normal;
    line-height: 0.875rem;
    letter-spacing: 0.03188rem;
    padding: 0.6875rem 2rem;
    text-transform: uppercase;
    cursor: pointer;
    display: block;
    text-align: center;
  }
  .btn-primary {
    background-color: #09538b;
    color: #fff;
    border: 0.125rem solid #09538b;
  }
  .btn-primary:hover {
    color: #fff;
    background-color: #053756;
    border: 0.125rem solid #053756;
    text-decoration: none;
  }
  .btn-primary:disabled {
    background-color: #6996b7;
    border: 0.125rem solid #6996b7;
  }
  @media only screen and (min-width: 64em) {
    .btn {
      font-size: 0.875rem;
      letter-spacing: 0.0375rem;
      padding: 0.625rem 2.5rem;
      line-height: 1.0625rem;
      display: inline-block;
    }
    a:focus,
    button:focus {
      outline: 2px solid #2d2c2c !important;
    }
  }
	
  .cthp-text-field.hide,
  .cthp-input-field { display: none; }

    .feedback__window {
  

      border:1px solid #ececec;
      border-radius: 4px;
      transition: all 0.5s ease;
      /* box-shadow: 0 .5rem 1rem 0 #e7e9f2;
      -webkit-box-shadow: 0 .5rem 1rem 0 #e7e9f2; */
      box-shadow: 0 .5rem 1rem 0 rgba(0, 0, 0, 0.19);
      -webkit-box-shadow: 0 .5rem 1rem 0 rgba(0, 0, 0, 0.19);
      right: -400px;

      position: fixed;
      width: 400px;
      top: 120px;
      background: #fff;
      padding: 1rem 1rem 2rem;
      font-size: 1.2rem;
      font-family: "Karla-Regular", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    }

    .feedback__main {
      display:none;
    }
    .feedback__main.is-visible { 
      display:block;
    }
    @media (max-width: 767.98px) {
      .feedback__window {
        top:0;

      }
      .feedback__window.is-open {
        right:0;
        width:100%;
        overflow-y: scroll;
        max-height: 100vh;
      }
      .feedback__main {
        position: relative;
        height: 450px;
      }
    }
    .feedback__window h1 {
      font-size: 24px;
      margin-bottom: 1em;
    }
    .submit-btn {
      background: #008939;
      border-color: #008939;
      width: 100%;
      height:40px;
    }
    .submit-btn:hover,
    .submit-btn:focus {
      background: #fff;
      border-color: #008939;
      color:#008939;
    }

    .is-open {
      right: 25px;
    }

    
    .ctgov-global-feedback-fieldset {
      margin-bottom: 2rem;
    }

    .validation-error {
      color:#db2426;
      padding:1rem; 
      font-size:14px;
    }

    .err {
      border: 1px solid #db2426;
    }

    .rating input[type="radio"]:not(:nth-of-type(0)) {
      /* hide visually */
      border: 0;
      clip: rect(0 0 0 0);
      height: 1px;
      margin: -1px;
      overflow: hidden;
      padding: 0;
      position: absolute;
      width: 1px;
    }

    .rating [type="radio"]:not(:nth-of-type(0))+label {
      display: none;
    }

    label[for]:hover {
      cursor: pointer;
    }

    .rating .stars label:before {
      content: "★";
      -webkit-text-stroke-width: 1px;
      -webkit-text-stroke-color: #333;
    } 

    /* .reload {
      font-family: Lucida Sans Unicode
    } */

    .stars label {
      color: #fff;
      margin: 0;
      font-size: 32px;
    }

    .stars label:hover {
      text-shadow: 0 0 1px #000;
    }

    .stars {
      display: flex;
      justify-content: space-evenly;
      background: #ececec;
      border-radius: 4px;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    }

    .rating [type="radio"]:nth-of-type(1):checked~.stars label:nth-of-type(-n+1),
    .rating [type="radio"]:nth-of-type(2):checked~.stars label:nth-of-type(-n+2),
    .rating [type="radio"]:nth-of-type(3):checked~.stars label:nth-of-type(-n+3),
    .rating [type="radio"]:nth-of-type(4):checked~.stars label:nth-of-type(-n+4),
    .rating [type="radio"]:nth-of-type(5):checked~.stars label:nth-of-type(-n+5) {
      color: #BA5803;
    }

    .rating [type="radio"]:nth-of-type(1):focus~.stars label:nth-of-type(1),
    .rating [type="radio"]:nth-of-type(2):focus~.stars label:nth-of-type(2),
    .rating [type="radio"]:nth-of-type(3):focus~.stars label:nth-of-type(3),
    .rating [type="radio"]:nth-of-type(4):focus~.stars label:nth-of-type(4),
    .rating [type="radio"]:nth-of-type(5):focus~.stars label:nth-of-type(5) {
      color: #ff831d;
    }

    .ctgov-global-feedback-form-textarea {
      background: #ececec;
      border-radius: 4px;
      width: 100%;
      border: none;
      min-height: 120px;
    }

    .err {
      border: 1px solid #db2426;
    }
  
.feedback__response { 
  text-align:center;
  margin-top: 2rem;
} 

.reload {
  font-size:18px;
  font-family: Lucida Sans Unicode;
}

.reload-btn {
  margin:0 auto;
  background:#43ac6a;
  border-color:#43ac6a;
}

.reload-btn:hover,
.reload-btn:focus {
  background: #2d8d60;
  border-color: #2d8d60;
}

.reload-btn-error {
  background:transparent;
  color:#db2426;
  border:1px solid #db2426;
  margin:0 auto;
}

.feedback__success-circle {
  text-align: center;
  margin-bottom: 1em;
  border: 4px solid #43ac6a;
  position: relative;
  display: inline-block;
  border-radius: 50%;
  width: 7em;
  height: 7em;
}

.feedback__error-circle {
  text-align: center;
  margin-bottom: 1em;
  border: 4px solid #db2426;
  position: relative;
  display: inline-block;
  border-radius: 50%;
  width: 5em;
  height: 5em;
}

.feedback__error-point { 
  font-size: 3.5rem;
  color: #db2426;
}

.feedback__success-checkmark.draw:after {
  animation-duration: 800ms;
  animation-timing-function: ease;
  animation-name: feedback-checkmark;
  transform: scaleX(-1) rotate(135deg);
}

.feedback__success-checkmark:after {
  opacity: 1;
  height: 3.5em;
  width: 1.75em;
  transform-origin: left top;
  border-right: 4px solid #43ac6a;
  border-top: 4px solid #43ac6a;
  content: "";
  left: 1.75em;
  top: 3.5em;
  position: absolute;
}

.feedback__success-message {
  text-align: center;
}


@keyframes feedback-checkmark {
  0% {
    height: 0;
    width: 0;
    opacity: 1;
  }

  20% {
    height: 0;
    width: 1.75em;
    opacity: 1;
  }

  40% {
    height: 3.5em;
    width: 1.75em;
    opacity: 1;
  }

  100% {
    height: 3.5em;
    width: 1.75em;
    opacity: 1;
  }
}


 
</style>